import {useMemo} from "react";
import _ from "underscore";

import defaultRules from "./rules/default-rules.ts";
import type {MarkdownRules} from "./types.ts";

/**
 * useMarkdownRules is a hook that returns set of markdown rules to be used
 * for parsing markdown content. It accepts overrides for modifying the default
 * rules.
 */
const useMarkdownRules = (overrideRules?: MarkdownRules): MarkdownRules => {
    return useMemo(() => {
        return overrideRules
            ? _.extend({}, defaultRules, overrideRules)
            : defaultRules;
    }, [overrideRules]);
};

export default useMarkdownRules;
